import styled from 'styled-components';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Button from '@sdk/components/ui/buttons/Button';
import gettext from '@sdk/lang/gettext';
import Picker from '@sdk/components/forms/Picker';
import TextareaAutoheight from '@sdk/components/forms/TextareaAutoheight';
import FieldLabel from '@sdk/components/forms/components/FieldLabel';

import { ButtonContainer } from '@web/components/survey/ButtonContainer';
import SurveyStep from '@web/components/survey/SurveyStep';
import { useReasonStep } from '@web/components/survey/SurveyReasonStep/useReasonStep.hooks';

export const ReasonStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
  line-height: 28px;
`;

interface Option {
  value: string;
  label: string;
}

type Props = {
  reason: string;
  setReason: (reason: string) => void;
  reasonOptions: Option[];
  other?: string;
  setOther?: (other: string) => void;
  stepNumber?: number;
  stepsCount?: number;
  subtitle?: string;
  submitStep: () => void;
};

export const SurveyReasonStep = ({
  reason,
  setReason,
  other,
  setOther,
  stepNumber,
  stepsCount,
  reasonOptions,
  subtitle,
  submitStep,
}: Props) => {
  const { commentInputRef, isCommentVisible, isValid } = useReasonStep(reason, other);

  return (
    <SurveyStep subtitle={subtitle} number={stepNumber} count={stepsCount}>
      <ReasonStepContainer>
        <Picker
          options={reasonOptions}
          placeholder={gettext('Please select')}
          value={reason}
          onChange={(value: string) => setReason(value)}
          showMenuAbove
        />

        {isCommentVisible && (
          <div>
            <FieldLabel
              label={gettext('Please specify')}
              htmlFor="other-reason-comment"></FieldLabel>
            <TextareaAutoheight
              id="other-reason-comment"
              ref={commentInputRef}
              placeholder={gettext('Type your comment...')}
              onChange={(e) => setOther(e.target.value)}
              maxLength={100}
            />
          </div>
        )}
      </ReasonStepContainer>

      <ButtonContainer>
        <Button disabled={!isValid} buttonType={ButtonType.primary} onClick={submitStep}>
          {gettext('Next')}
        </Button>
      </ButtonContainer>
    </SurveyStep>
  );
};
